var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center h-[50px]",attrs:{"data-component":"ChatDateSeparator","data-version":"2"}},[_c(_setup.CsBadge,[_vm._v("\n    "+_vm._s(_setup.formattedDate)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }